import styled, { css } from 'styled-components'

import { parcelStatusVariants } from './constants'

export const Container = styled.div`
  display: flex;
  background-color: ${props => props.backgroundColor};

  ${props =>
    props.variant === parcelStatusVariants.cards &&
    css`
      gap: ${props => props.theme.spacing.sp8};
      justify-content: start;
      align-items: center;
      height: ${props => props.theme.size.XL};
      padding: ${props => `0 ${props.theme.spacing.sp16}`};
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      min-width: 148px;
    `}

  ${props =>
    props.variant === parcelStatusVariants.table &&
    css`
      gap: ${props => props.theme.spacing.sp4};
      justify-content: center;
      align-items: center;
      height: ${props => props.theme.size.XS};
      min-width: 130px;
      border-radius: ${props => props.theme.primitives.radius.radius4};
    `}


    ${props =>
    props.variant === parcelStatusVariants.previewDetail &&
    css`
      gap: ${props => props.theme.spacing.sp8};
      justify-content: start;
      align-items: center;
      padding: 0 16px;
      height: ${props => props.theme.size.XL};
    `}
`
